import React, { useEffect, useState } from 'react'
import * as routeLink from "../../constants/routeLink";
import { useNavigate } from 'react-router-dom';
import { createChart } from 'lightweight-charts';
import { useSelector } from 'react-redux';
import { bet, domain, getChartData, history, } from '../../services/services';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
let chart
let area

const Index = (props) => {
  const [timeChart, setTimeChart] = useState('1m');

  return (
    <div className="w-full">
      <form className="ant-form ant-form-horizontal css-sic622">
        <div className="lg:mx-auto px-[4.8%] lg:px-0 py-8 lg:py-[74px] w-full lg:w-[741px] min-w-0">
          <div className="flex-v lg:flex-h items-center gap-6 lg:gap-12 w-full">
            <div className="w-[177px] h-[177px]"><span
              className="ant-upload-wrapper avatar-uploader css-sic622 ant-upload-picture-card-wrapper">
              <div className="ant-upload ant-upload-select"><span className="ant-upload">
                <input
                type="file" accept="" style={{display: "none"}}/>
                <div
                  className="relative flex-v justify-end items-center pb-3 w-[152px] h-[108px] ant-upload-button-bg">
                  <span
                    className="top-0 absolute mx-auto t-500-12-gray">jpeg/png/webp/gif
                    <div>( &lt; 5MB )</div></span><span
                      className="bg-white px-[8.5px] py-[5.5px] rounded-[7px] w-fit text-[#0F0F0F] text-[10px]">Select
                    Media</span></div>
              </span></div>
            </span></div>
            <div className="flex-1 flex-v gap-5 w-full">
              <div className="undefined w-full  flex-v gap-[6px] "><span
                className="t-600-14-white lg:t-600-16-white">Token Name<i
                  className="font-bold text-[16px] text-[#76F951]"> *</i></span>
                <div className="ant-form-item css-sic622">
                  <div className="ant-row ant-form-item-row css-sic622">
                    <div className="ant-col ant-form-item-control css-sic622">
                      <div className="ant-form-item-control-input">
                        <div className="ant-form-item-control-input-content"><input
                          name="name" id="name"
                          className="ant-input css-sic622 ant-input-outlined baseInput"
                          type="text" value=""/></div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="undefined w-full  flex-v gap-[6px] "><span
                className="t-600-14-white lg:t-600-16-white">Ticker Symbol<i
                  className="font-bold text-[16px] text-[#76F951]"> *</i></span>
                <div className="ant-form-item css-sic622">
                  <div className="ant-row ant-form-item-row css-sic622">
                    <div className="ant-col ant-form-item-control css-sic622">
                      <div className="ant-form-item-control-input">
                        <div className="ant-form-item-control-input-content"><input
                          name="shortName" id="shortName"
                          className="ant-input css-sic622 ant-input-outlined baseInput"
                          type="text" value=""/></div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="flex-v gap-[14px] lg:gap-5 mt-5 w-full">
            <div className="undefined w-full  flex-v gap-[6px] "><span
              className="t-600-14-white lg:t-600-16-white">Description<i
                className="font-bold text-[16px] text-[#76F951]"> *</i></span>
              <div className="ant-form-item css-sic622">
                <div className="ant-row ant-form-item-row css-sic622">
                  <div className="ant-col ant-form-item-control css-sic622">
                    <div className="ant-form-item-control-input">
                      <div className="ant-form-item-control-input-content"><textarea
                        placeholder="" name="desc" id="desc"
                        className="ant-input css-sic622 ant-input-outlined"></textarea>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="undefined w-full  flex-v gap-[6px] "><span
              className="t-600-14-white lg:t-600-16-white">Website</span>
              <div className="ant-form-item css-sic622">
                <div className="ant-row ant-form-item-row css-sic622">
                  <div className="ant-col ant-form-item-control css-sic622">
                    <div className="ant-form-item-control-input">
                      <div className="ant-form-item-control-input-content"><input
                        maxlength="200" placeholder="optional" name="webUrl"
                        id="webUrl"
                        className="ant-input css-sic622 ant-input-outlined baseInput"
                        type="text" value=""/></div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="undefined w-full  flex-v gap-[6px] "><span
              className="t-600-14-white lg:t-600-16-white">Twitter</span>
              <div className="ant-form-item css-sic622">
                <div className="ant-row ant-form-item-row css-sic622">
                  <div className="ant-col ant-form-item-control css-sic622">
                    <div className="ant-form-item-control-input">
                      <div className="ant-form-item-control-input-content"><input
                        maxlength="200" placeholder="optional" name="twitterUrl"
                        id="twitterUrl"
                        className="ant-input css-sic622 ant-input-outlined baseInput"
                        type="text" value=""/></div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="undefined w-full  flex-v gap-[6px] "><span
              className="t-600-14-white lg:t-600-16-white">Telegram</span>
              <div className="ant-form-item css-sic622">
                <div className="ant-row ant-form-item-row css-sic622">
                  <div className="ant-col ant-form-item-control css-sic622">
                    <div className="ant-form-item-control-input">
                      <div className="ant-form-item-control-input-content"><input
                        maxlength="200" placeholder="optional"
                        name="telegramUrl" id="telegramUrl"
                        className="ant-input css-sic622 ant-input-outlined baseInput"
                        type="text" value=""/></div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="flex-h-cc gap-[13px] w-fit"><button type="button" role="switch"
              aria-checked="false" className="ant-switch css-sic622">
              <div className="ant-switch-handle"></div><span className="ant-switch-inner"><span
                className="ant-switch-inner-checked"></span><span
                  className="ant-switch-inner-unchecked"></span></span>
            </button><span className="font-bold text-[16px] text-white">Extra Options</span>
            </div>
          </div>
          <div className="flex-v-cc gap-2 mt-[46px] w-full"><span
            className="font-bold text-[#545C68] text-[16px]">Cost to deploy: 0.005
            BNB</span><button type="button"
              className="ant-btn css-sic622 ant-btn-primary w-full h-[48px] rounded-[15px] "><span>Connect
                Wallet</span></button></div>
        </div>
      </form>
    </div>
  )
}

export default Index;
